<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    v-dialog(v-model='dialog6', persistent max-width='1000px')
      v-card
        v-card-text
          v-container(id="printJS-form2")
            div(align='center')
              h5(style='font-weight: 400 !important;') COBROS
            div(align='center')
              img(src='../assets/logo.png', style='width: 200px;margin-top: -20px;margin-bottom: -15px;')
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Nro
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.nro}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Fecha
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.fechaC | moment('DD/MM/YYYY H:mm A')}}
              tr(v-if='form.metodo && form.metodo.nombre')
                td.withTd2(align='center' style="padding:0px;")
                  b Método de pago
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.metodo.nombre}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Vendedor
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.vendedor}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Cliente
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.cliente.cli_des}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Titular
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.titular') {{form.titular}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Titular rif
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.rifTitular') {{form.rifTitular}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Facturas
                td.withTd2(align='center' style="padding:0px;")
                  div(v-for='item in form.facturas')
                    b {{item}}
              tr(v-if="form.tasa")
                td.withTd2(align='center' style="padding:0px;")
                  b Tasa
                td.withTd2(align='center' style="padding:0px;")
                  b {{form.tasa}}BSD
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Total
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.moneda == "BSD" && form.tasa') ${{transformMonto(form.monto, form.tasa)}} ({{form.monto}}BSD)
                  b(v-if='form.moneda == "BSD" && !form.tasa') {{form.monto}}BSD
                  b(v-if='form.moneda == "US"') ${{form.monto}}
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Referencia
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.referencia') {{form.referencia}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Observación
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.observacion') {{form.observacion}}
                  b(v-else) N/A
              tr
                td.withTd2(align='center' style="padding:0px;")
                  b Descripción
                td.withTd2(align='center' style="padding:0px;")
                  b(v-if='form.descripcion') {{form.descripcion}}
                  b(v-else) N/A
            div(v-if='form.bauche' style="display: flex;justify-content: center;margin-top:20px;")
              img(:src='ruta + form.bauche' style='width: auto;height: 600px;object-fit:contain;')
            div(v-if='form.bauche2' style="display: flex;justify-content: center;margin-top:20px;")
              img(:src='ruta + form.bauche2' style='width: auto;height: 600px;object-fit:contain;')
            div(v-if='form.bauche3' style="display: flex;justify-content: center;margin-top:20px;")
              img(:src='ruta + form.bauche3' style='width: auto;height: 600px;object-fit:contain;')
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close4()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf2()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog3', persistent max-width='85%')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(align='center')
              h5(style='font-weight: 400 !important;text-decoration: underline;' v-if='dates && dates.length > 0') COBROS {{dates[0]}} - {{dates[1]}}
            br
            table(border="0" align="center" style='width: 100%;')
              tr
                td(align='center').withTd2
                  b N°
                td(align='center').withTd2
                  b FECHA
                td(align='center' style="line-height: 16px;").withTd2
                  b FECHA PAGO
                td(align='center').withTd2
                  b VENDEDOR
                td(align='center').withTd2
                  b CLIENTE
                td(align='center').withTd2
                  b METODO
                td(align='center').withTd2
                  b TOTAL
                td(align='center').withTd2
                  b REFERENCIA
                td(align='center').withTd2
                  b DESCRIPCIÓN
                td(align='center').withTd2
                  b ESTATUS
              tr(v-for='item in resultados')
                td(align='center').withTd2
                  b {{item.nro}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.fechaC | moment('DD/MM/YYYY H:mm A')}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.fechaP | moment('DD/MM/YYYY H:mm A')}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.vendedor}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.cliente.cli_des}}
                td(v-if='form.metodo && form.metodo.nombre' align='center' style="line-height: 16px;").withTd2
                  b {{item.metodo.nombre}}
                td(align='center' style="line-height: 16px;").withTd2
                  b(v-if="item.tasa") {{item.tasa}}
                  b(v-else) N/A
                td(align='center').withTd2
                  b(v-if='item.moneda == "BSD" && item.tasa') ${{transformMonto(item.monto, item.tasa)}} ({{item.monto}}BSD)
                  b(v-if='item.moneda == "BSD" && !item.tasa') {{item.monto}}BSD
                  b(v-if='item.moneda == "US"') ${{item.monto}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.referencia}}
                td(align='center' style="line-height: 16px;").withTd2
                  b {{item.descripcion}}
                td(align='center').withTd2
                  b {{item.estatus}}

        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog7', persistent max-width='1000px')
          v-container(style='background-color:white !important;max-width: 1000px;')
            v-card-title.justify-center
              span.headline Cobro
            div(style="margin-top: 10px;" v-if='itemMov')
              v-flex(xs12, sm12, md12)
                v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
                  v-flex(xs4 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Nro:
                      span {{itemMov.nro}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha:
                      span {{transform2(itemMov.fechaC)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha de pago:
                      span {{transform(itemMov.fechaP)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Moneda:
                      span(v-if='!itemMov.moneda') N/A
                      span(v-else) {{itemMov.moneda}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Tasa:
                      span(v-if='itemMov.tasa') {{itemMov.tasa}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Valija:
                      span {{itemMov.nroValija}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Vendedor:
                      span {{itemMov.vendedor}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Cliente:
                      span(v-if='itemMov.clienteN') {{itemMov.clienteN}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Rif Titular:
                      span(v-if='itemMov.rifTitular') {{itemMov.rifTitular}}
                      span(v-else) N/A
                    div(v-if='itemMov.metodo && itemMov.metodo.nombre')
                      span(style='font-weight:500;padding-right:3px;') Método:
                      span {{itemMov.metodo.nombre}}
                  v-flex(xs3 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Monto:
                      span(v-if='itemMov.moneda == "BSD" && itemMov.tasa') ${{ transformMonto(itemMov.monto, itemMov.tasa) }} ({{itemMov.monto}}BSD)
                      span(v-if='itemMov.moneda == "BSD" && !itemMov.tasa') {{itemMov.monto}}BSD
                      span(v-if='itemMov.moneda == "US"') ${{itemMov.monto}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Referencia:
                      span(v-if='itemMov.referencia') {{itemMov.referencia}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Cobro:
                      span(v-if='itemMov.nroCobro') {{itemMov.nroCobro}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Estatus:
                      span {{itemMov.estatus}}
            v-card-title.justify-center
              span.headline Posibles movimientos asociados
            div(style="margin-top: 10px;")
              v-flex(xs12, sm12, md12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-flex(xs12)
                    v-form(enctype="multipart/form-data")

                      v-data-table.elevation-1(v-model="selectMov" :single-select="true" item-key="_id" :headers='headersMov' :pagination.sync="paginationMov" :items="resultadosMov" style="margin-top: 5px;")
                        template(slot='items', slot-scope='props')
                          td
                            v-checkbox(
                              :value='props.item'
                              style='margin: 0px;padding: 0px;'
                              hide-details=''
                              v-model="selectMov"
                            )
                          td {{ transform(props.item.fecha)}}
                          td {{ props.item.descripcion }}
                          td {{ props.item.banco }}
                          td {{ props.item.monto }}
                          td {{ props.item.referencia }}
                          td {{ props.item.estatus }}

                      div
                        v-flex(v-if="loading === true", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-progress-circular(indeterminate='', color='primary')
                        v-flex(v-if="loading === false", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                              v-btn(v-if='selectMov && selectMov.length > 0' style="background:green;border-radius:10px;", @click.native='editItemAproMov') Guardar
                              v-btn(style="background:black;border-radius:10px;", @click.native='closeMov') Salir
    v-dialog(v-model='dialog8', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:green;border-radius:10px;", @click.native='saveRef') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='closeRef') Salir
    v-dialog(v-model='dialog9', persistent max-width='500px')
          v-container(style='background-color:white !important;max-width: 500px;')
            v-card-title.justify-center
                span.headline Fecha Pago
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                          v-menu(ref='menu2' v-model='modal2' :close-on-content-click='false' transition='scale-transition' offset-y='')
                            template(v-slot:activator='{ on, attrs }')
                              v-text-field(outline v-model='dateFormatted' label='Fecha' persistent-hint='' v-bind='attrs' @blur='form.fechaP = parseDate(dateFormatted)' v-on='on')
                            v-date-picker(v-model='form.fechaP' no-title='' @input='modal2 = false' dark='')

                          div
                            v-flex(v-if="loading === true", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                v-progress-circular(indeterminate='', color='primary')
                            v-flex(v-if="loading === false", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-btn(style="background:green;border-radius:10px;", @click.native='saveFecha') Guardar
                                  v-btn(style="background:black;border-radius:10px;", @click.native='close9') Salir
    v-dialog(v-model='dialog5', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-if='form.tasa'
                            type='number'
                            v-model="form.tasa"
                            prepend-inner-icon="description"
                            label="Tasa:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:green;border-radius:10px;", @click.native='saveMonto') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='closeMonto') Salir
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            v-if='form.metodo && form.metodo.nombre'
                            readonly
                            v-model="form.metodo.nombre"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-text-field(outline
                            v-if='form.rifTitular'
                            readonly
                            v-model="form.rifTitular"
                            prepend-inner-icon="description"
                            label="Titular rif:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.tasa"
                            v-if='form.tasa'
                            prepend-inner-icon="description"
                            label="Tasa:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Total:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche' style='width: 425px;height: auto;')

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche2')
                              a(:href='ruta + form.bauche2' target='_blank')
                                img(:src='ruta + form.bauche2' style='width: 425px;height: auto;')

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche3')
                              a(:href='ruta + form.bauche3' target='_blank')
                                img(:src='ruta + form.bauche3' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.nroCobro'
                              v-model="form.nroCobro"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de cobro:")

                            v-text-field(outline
                              v-if='form.nroAJNM'
                              v-model="form.nroAJNM"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de AJNM:")

                            v-text-field(outline
                              v-if='form.nroADEL'
                              v-model="form.nroADEL"
                              readonly
                              prepend-inner-icon="description"
                              label="Nro. de ADEL:")

                            v-text-field(outline
                              v-if='form.referencia'
                              v-model="form.referencia"
                              prepend-inner-icon="description"
                              label="Referencia:")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='(form.estatus === "Aprobado" || form.estatus === "Conciliado")' style="background:green;border-radius:10px;", @click.native='save("P")') Procesado
                                    v-btn(v-if='form.estatus === "Pendiente" && form.metodo.tipo == "Efectivo"' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs3)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='aplicarFiltros()')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='metodos' v-model="seleccionFiltroM" label="Métodos" @change='aplicarFiltros()')
            v-flex(xs3 style='display: flex;align-items: center;justify-content: flex-end;')
              //- v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              //-   template(v-slot:activator='{ on, attrs }')
              //-     v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
              //-   v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#2c489e' style='font-size: 1.70rem;') search
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Safiro-Cobros'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span Cobros
              vue-excel-xlsx( v-if='resultados2 && resultados2.length > 0' :data='dataExcel2' :columns='columnsExcel2' :filename="'Safiro-Cobros-Vendedores'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span T.C.V
              a(style='margin-right: 12px;' @click="dialog3 = true")
                img(src='../assets/pdf.svg', style="height: 60px;width: auto;object-fit: contain;")
            v-flex(xs12 v-if='selected.length > 0')
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-btn(v-if='selected[0].estatus === "Aprobado" || selected[0].estatus === "Conciliado"' style="background:green;border-radius:10px;", @click.native='saveAll("P")') Procesar
                //- v-btn(v-if='selected[0].estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='saveAll("A")') Aprobar
                v-btn(v-if='selected[0].estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='saveAll("R")') Rechazar
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(v-model="selected" :single-select="false" item-key="nro" ref='tablet1' :headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" :custom-filter="filterPerfectMatch" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td 
              v-checkbox(
                :value='props.item'
                v-if="props.item.estatus == 'Pendiente' || (props.item.estatus == 'Conciliado') || (props.item.estatus == 'Aprobado')"
                style='margin: 0px;padding: 0px;'
                hide-details=''
                v-model="selected"
              )
            td {{ props.item.nro}}
            td {{ transform2(props.item.fechaC)}}
            td {{ transform(props.item.fechaP)}}
            td(v-if='!props.item.moneda') N/A
            td(v-else) {{props.item.moneda}}
            td(v-if='props.item.tasa') {{ props.item.tasa }}
            td(v-else) N/A
            td {{ props.item.nroValija }}
            td {{ props.item.vendedor }}
            td(v-if='props.item.clienteN') {{ props.item.clienteN }}
            td(v-else) N/A
            td(v-if='props.item.metodo && props.item.metodo.nombre') {{ props.item.metodo.nombre }}
            td(v-else) N/A
            td(v-if='props.item.moneda == "BSD" && props.item.tasa') ${{ transformMonto(props.item.monto, props.item.tasa) }} ({{props.item.monto}}BSD)
            td(v-if='props.item.moneda == "BSD" && !props.item.tasa') {{props.item.monto}}BSD
            td(v-if='props.item.moneda == "US"') ${{props.item.monto}}
            td(v-if='props.item.referencia') {{ props.item.referencia}}
            td(v-else) N/A
            td(v-if='props.item.nroCobro') {{ props.item.nroCobro}}
            td(v-else) N/A
            td {{ props.item.estatus}}
            td.justify-center.layout.px-0
              v-layout(wrap)
                v-flex(xs4 v-if='mod')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') edit
                    | Editar.
                v-flex(xs4  v-if='mod && (props.item.estatus === "Pendiente" || props.item.estatus === "Aprobado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemReferencia(props.item)' v-on="on" color='orange') description
                    | Editar Referencia.
                v-flex(xs4  v-if='mod && (props.item.estatus === "Pendiente" || props.item.estatus === "Aprobado" || props.item.estatus === "Conciliado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemMonto(props.item)' v-on="on" color='teal') description
                    | Editar Monto.
                v-flex(xs4  v-if='mod && props.item.estatus === "Pendiente"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemFecha(props.item)' v-on="on" color='teal') description
                    | Editar Fecha P.
                v-flex(xs4)
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemPdf(props.item)' v-on="on" color='red') description
                    | PDF
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo.tipo == "Efectivo"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "A")' v-on="on" color='teal') check_circle
                    | Aprobar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo.tipo  !== "Efectivo" && !props.item.coincide')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="blue") description
                    | Conciliar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo.tipo  !== "Efectivo" && props.item.coincide')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="black") description
                    | Conciliar.
                v-flex(xs4 v-if='mod && props.item.estatus === "Pendiente"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "R")' v-on="on" color='red') cancel
                    | Rechazar.
                v-flex(xs4 v-if='mod && (props.item.estatus == "Aprobado" || props.item.estatus == "Conciliado")')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='editItemApro(props.item, "P")' v-on="on" color='teal') cloud
                    | Procesar.
                v-flex(xs4 v-if='mod && props.item.estatus == "Conciliado"')
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-icon.mr-2(@click='reversarConciliacion(props.item)' v-on="on" color='teal') undo
                    | Reversar Conciliación.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import printJS from 'print-js'
export default {
  name: "Cobros",
  data: vm => ({
    selected: [],
    json_data: [],
    itemMov: null,
    typeMov: null,
    selectMov: [],
    resultadosMov: [],
    resultadosMovAll: [],
    dialog3: false,
    dialog5: false,
    dialog6: false,
    dialog7: false,
    dialog8: false,
    dialog9: false,
    ruta: serverImg,
    dates: [],
    loading: false,
    dialog4: false,
    seleccionFiltro: 'todos',
    seleccionFiltroM: 'todos',
    metodos: [],
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Conciliados",
        value: "Conciliado"
      },
      {
        text: "Aprobados",
        value: "Aprobado"
      },
      {
        text: "Rechazados",
        value: "Rechazado"
      },
      {
        text: "Procesados",
        value: "Procesado"
      },
      {
        text: "Finalizados",
        value: "Finalizado"
      },
    ],
    itemsF: [],
    dataExcel: [],
    dataExcel2: [],
    resultados2: [],
    columnsExcel2: [
      {
        label: "Fecha inicial",
        field: "fecha",
      },
      {
        label: "Código",
        field: "co_ven",
      },
      {
        label: "Vendedor",
        field: "ven_des",
      },
      {
        label: "Total efectivo",
        field: "total",
      },
    ],
    columnsExcel: [
      {
        label: "N° Web",
        field: "nro",
      },
      {
        label: "Fecha",
        field: "fechaC",
      },
      {
        label: "Fecha de pago",
        field: "fechaP",
      },
      {
        label: "Moneda",
        field: "moneda",
      },
      {
        label: "Tasa",
        field: "tasa",
      },
      {
        label: "N° Valija",
        field: "nroValija",
      },
      {
        label: "Vendedor",
        field: "vendedor",
      },
      {
        label: "Cliente",
        field: "cliente",
      },
      {
        label: "Método",
        field: "metodo",
      },
      {
        label: "Total $",
        field: "monto",
      },
      {
        label: "Total BSD",
        field: "montoBS",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Titular",
        field: "titular",
      },
      {
        label: "Titular rif",
        field: "rifTitular",
      },
      {
        label: "Nro. Cobro",
        field: "nroCobro",
      },
      {
        label: "Facturas",
        field: "facturas",
      },
      {
        label: "Descripción",
        field: "descripcion",
      },
      {
        label: "Comentario Valija",
        field: "comentValija",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    pagination: {
      sortBy: 'fechaC', // The field that you're sorting by
      descending: true,
      page: 1,
      rowsPerPage: 25,
    },
    paginationMov: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    modal2: false,
    search: "",
    form: {
      _id: "",
      nro: "",
      nroCobro: "",
      titular: "",
      moneda: "",
      tasa: "",
      rifTitular: "",
      nroAJNM: "",
      nroADEL: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: 0,
      referencia: "",
      descripcion: "",
      bauche: "",
      bauche2: "",
      bauche3: "",
      metodo: {},
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headersMov: [
      { text: "Check", value: "check" },
      { text: "Fecha", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" }
    ],
    headers: [
      { text: "Check", value: "check" },
      { text: "Nro", value: "nro" },
      { text: "Fecha", value: "fechaC" },
      { text: "Fecha de pago", value: "fechaP" },
      { text: "Moneda", value: "moneda" },
      { text: "Tasa", value: "tasa" },
      { text: "N° Valija", value: "nroValija" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "clienteN" },
      { text: "Método", value: "metodo" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Nro. Cobro", value: "nroCobro" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción", value: "accion" }
    ],
    defaultForm: {
      _id: "",
      nro: "",
      nroCobro: "",
      titular: "",
      rifTitular: "",
      vendedor: "",
      nroADEL: "",
      moneda: "",
      tasa: "",
      nroAJNM: "",
      cliente: {},
      facturas: [],
      monto: 0,
      descripcion: "",
      referencia: "",
      bauche: "",
      bauche2: "",
      bauche3: "",
      metodo: {},
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    selected(val) {
      if (val.length > 1) {
        const primerEstatus = val[0].estatus; // Obtener el estatus del primer registro
        for (let i = val.length - 1; i >= 0; i--) {
          if (val[i].estatus !== primerEstatus) {
            this.$swal.fire({
              position: "top-end",
              icon: "error",
              html: "<span style='font-size:20px;'>El registro con estatus "+this.selected[i].estatus+" no coincide los anteriores</span>",
              showConfirmButton: false,
              timer: 1500
            });
            this.selected.splice(i, 1);
          }
        }
      }
    },
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    "form.fechaP": function(val) {
      if (val && this.dialog9) {
        this.dateFormatted = this.formatDate(this.form.fechaP)
      }
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    reversarConciliacion(item) {
      this.dialog4 = true;
      let info = {
        _id: item._id,
        referencia: item.referenciaOld ? item.referenciaOld : item.referencia,
        referenciaOld: null,
        estatus: "Pendiente"
      }
      info.usuario = this.$store.state.adminsafiro._id
      info.accion = 'Reverso de conciliacion, Nro: '+item.nro
      Api.put("cobros/reversarConciliacion", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == item._id.toString()) {
              el.estatus = info.estatus
              if (info.referencia) el.referencia = info.referencia
              if (info.referenciaOld) el.referenciaOld = null
            }
          })
          this.dialog4 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
        })
        .catch(err => {
          console.log(err);
          this.dialog4 = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    close4() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog6 = false;
    },
    close3() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog3 = false;
    },
    imprimirPdf () {
      printJS({
        printable: 'printJS-form',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        style: '@page { size: Letter landscape; }',
        css: 'printPdf'
      })
    },
    imprimirPdf2 () {
      printJS({
        printable: 'printJS-form2',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        style: '@page { size: Letter portrait; }',
        css: 'printPdf'
      })
    },
    transformMonto(monto, tasa) {
      if (tasa) {
        return parseFloat((parseFloat(monto) / parseFloat(tasa)).toFixed(2))
      } else return parseFloat(monto)
    },
    filterPerfectMatch(items, search, filter) {
      let inf = items
      search = search.toString().toLowerCase();
      if (search.trim() === '') {
        if (inf && inf.length > 0) {
          this.dataExcel = []
          for (let i = 0; i < inf.length; i++) {
            const el = inf[i];
            let fcct = ""
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (i == (el.facturas.length-1)) {
                fcct += el2.nro_doc.trim() + "."
              } else fcct += el2.nro_doc.trim() + ", "
            }
            this.dataExcel.push({
              _id: el._id,
              nro: el.nro,
              fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
              moneda: (el.moneda) ? el.moneda : "N/A",
              tasa: (el.tasa) ? el.tasa : "N/A",
              nroValija: (el.nroValija) ? el.nroValija : "N/A",
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: (el.metodo && el.metodo.nombre) ? el.metodo.nombre : 'N/A',
              monto: (el.moneda == "BSD" && el.tasa) ? this.transformMonto(el.monto, el.tasa) : (el.moneda == "US") ? el.monto : "N/A",
              montoBS: (el.moneda == "BSD") ? el.monto : 0,
              referencia: (el.referencia) ? el.referencia : "N/A",
              titular: (el.titular) ? el.titular : "N/A",
              rifTitular: (el.rifTitular) ? el.rifTitular : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              comentValija: (el.comentValija) ? el.comentValija : "N/A",
              estatus: el.estatus
            })
          }
        }
        return items;
      }
      inf = items.filter(function (i) {
          return Object.keys(i).some(function (j) {
              return filter(i[j], search);
          });
      });
      if (inf && inf.length > 0) {
        this.dataExcel = []
        for (let i = 0; i < inf.length; i++) {
          const el = inf[i];
          let fcct = ""
          for (let j = 0; j < el.facturas.length; j++) {
            const el2 = el.facturas[j];
            if (i == (el.facturas.length-1)) {
              fcct += el2.nro_doc.trim() + "."
            } else fcct += el2.nro_doc.trim() + ", "
          }
          this.dataExcel.push({
            _id: el._id,
            nro: el.nro,
            fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
            fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
            moneda: (el.moneda) ? el.moneda : "N/A",
            tasa: (el.tasa) ? el.tasa : "N/A",
            nroValija: (el.nroValija) ? el.nroValija : "N/A",
            vendedor: el.vendedor,
            cliente: el.cliente.cli_des,
            metodo: (el.metodo && el.metodo.nombre) ? el.metodo.nombre : "N/A",
            monto: (el.moneda == "BSD" && el.tasa) ? this.transformMonto(el.monto, el.tasa) : (el.moneda == "US") ? el.monto : "N/A",
            montoBS: (el.moneda == "BSD") ? el.monto : 0,
            referencia: (el.referencia) ? el.referencia : "N/A",
            titular: (el.titular) ? el.titular : "N/A",
            rifTitular: (el.rifTitular) ? el.rifTitular : "N/A",
            nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
            facturas: fcct,
            descripcion: el.descripcion,
            comentValija: (el.comentValija) ? el.comentValija : "N/A",
            estatus: el.estatus
          })
        }
      }
      return inf
    },
    transform2(date) {
      return this.$moment(date).format("DD/MM/YYYY H:mm A")
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    aplicarFiltros() {
      let filtroM = this.seleccionFiltroM;
      let filtroE = this.seleccionFiltro;

      this.resultados = []
      this.resultados = this.resultadosres.filter(el => {
        const cumpleFiltroB = (filtroM === "todos" || el.metodo._id === filtroM);
        const cumpleFiltroE = (filtroE === "todos" || el.estatus === filtroE);
        return cumpleFiltroB && cumpleFiltroE;
      });
      if (this.resultados && this.resultados.length > 0) {
        this.$nextTick(() => {
          for (let i = 0; i < this.resultados.length; i++) {
            let el = this.resultados[i];
            el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
          }
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        this.dialog4 = true
        this.selected = [];
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = []
        this.seleccionFiltro = "todos"
        this.seleccionFiltroM = "todos"
        this.search = ""
        Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.$nextTick(() => {
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
                let fact = []
                for (let j = 0; j < el.facturas.length; j++) {
                  const el2 = el.facturas[j];
                  if (typeof el2 === "string") {
                    fact = JSON.parse(el2)
                  } else fact.push(el2)
                }
                el.coincide = false;
                el.facturas = fact
                el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
                this.resultados.push(el)
                this.resultadosres.push(el)
              }
            }
            this.dialog4 = false
            this.buscarTodosMov()
          })
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    buscarTodosMov() {
      Api.get(`movimientos/pendientes`).then(res => {
        this.resultadosMovAll = res.data;
        this.resultadosres.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco._id === el.metodo._id &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
        this.resultados.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco._id === el.metodo._id &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
      })
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      this.dataExcel2 = []
      this.metodos = [
        {
          text: "Todos",
          value: "todos"
        }
      ]
      this.dialog4 = true;
      Api.get(`metodopago/modulo?modulo=CobroApp`).then(res => {
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.metodos.push({
              text: el.nombre,
              value: el._id,
            })
          }
        }
      }).catch(err=>{
        console.log(err)
      });
      Api.get("cobros/adminReporte").then(res => {
        this.resultados2 = []
        if (res.data && res.data.length > 0) {
          this.resultados2 = res.data
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.dataExcel2.push({
              fecha: this.$moment(el.fecha).utc().format('DD-MM-YYYY H:mm A'),
              co_ven: el.co_ven,
              ven_des: el.ven_des,
              total: el.total
            })
          }
        }
      }).catch(err=>{
        console.log(err)
      });
      Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = []
        this.resultadosres = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (typeof el2 === "string") {
                fact = JSON.parse(el2)
              } else fact.push(el2)
            }
            el.coincide = false;
            el.facturas = fact
            el.clienteN = el.cliente && el.cliente.cli_des ? el.cliente.cli_des.trim() : 'N/A'
            this.resultados.push(el)
            this.resultadosres.push(el)
          }
        }
        this.dialog4 = false;
        this.buscarTodosMov()
      }).catch(err=>{
        this.dialog4 = false;
        console.log(err)
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    editItemPdf(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog6 = true;
    },
    editItemReferencia(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog8 = true;
    },
    close9() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog9 = false;
    },
    editItemFecha(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.form.fechaP = this.$moment(this.form.fechaP).utc().format('YYYY-MM-DD')
      this.dateFormatted = this.formatDate(this.$moment(this.form.fechaP).utc().format('YYYY-MM-DD'))
      this.dialog9 = true;
    },
    editItemMonto(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog5 = true;
    },
    saveFecha() {
      let info = {
        _id: this.form._id,
        fechaP: this.form.fechaP
      }
      this.loading = true;
      info.usuario = this.$store.state.adminsafiro._id
      info.accion = 'Modificación de fecha, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.fechaP = info.fechaP
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog9 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    saveMonto() {
      let info = {
        _id: this.form._id,
        tasa: parseFloat(this.form.tasa)
      }
      this.loading = true;
      info.usuario = this.$store.state.adminsafiro._id
      info.accion = 'Modificación de montos, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.tasa) el.tasa = info.tasa
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.tasa) el.tasa = info.tasa
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.monto = info.monto
              if (info.tasa) el.tasa = info.tasa
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog5 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    closeMonto() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog5 = false;
    },
    saveRef() {
      let info = {
        _id: this.form._id,
        referencia: this.form.referencia
      }
      this.loading = true;
      info.usuario = this.$store.state.adminsafiro._id
      info.accion = 'Modificación de referencia, Nro: '+this.form.nro
      Api.put("cobros", info)
        .then(() => {
          this.resultados.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.resultadosres.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.dataExcel.forEach(el=>{
            if (el._id.toString() == this.form._id.toString()) {
              el.referencia = info.referencia
            }
          })
          this.form = Object.assign({}, this.defaultForm);
          this.dialog8 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          const errorMessage = err.response && err.response.data && err.response.data.error || err.message || 'Error desconocido';
          this.$swal.fire(
            "Oops...",
            errorMessage,
            "error"
          );
      });
    },
    closeRef() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog8 = false;
    },
    closeMov() {
      this.itemMov = null;
      this.typeMov = null;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = false;
    },
    buscarMovAso(item, type) {
      this.itemMov = item;
      this.typeMov = type;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = true;
      this.dialog4 = true;
      Api.get(`movimientos/coincidencias?fecha=${item.fechaP}&banco=${item.metodo._id}&monto=${item.monto}&ref=${item.referencia}`).then(res => {
        this.resultadosMov = res.data;
        this.dialog4 = false;
      }).catch(err=>{
        console.log(err)
        this.$swal.fire(
          "¡Atención!",
          err,
          "error"
        );
        this.dialog4 = false;
      });
    },
    editItemAproMov() {
      if (this.selectMov && this.selectMov.length > 0) {
        Object.keys(this.form).map(key => {
          if (this.itemMov[key]) this.form[key] = this.itemMov[key];
        });
        this.itemsF = []
        this.form.facturas = []
        for (let i = 0; i < this.itemMov.facturas.length; i++) {
          const el = this.itemMov.facturas[i];
          this.itemsF.push({
            value: el.nro_doc,
            text: el.nro_doc
          })
          this.form.facturas.push(el.nro_doc)
        }
        this.form._id = this.itemMov._id;
        this.save(this.typeMov, this.selectMov)
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debe seleccionar un movimiento para continuar",
          "error"
        );
      }
    },
    editItemApro(item, type) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.save(type)
    },
    actualizarEstatusYObservacion(array, selected, info) {
      selected.forEach(el2 => {
        const match = array.find(el => el._id.toString() === el2._id.toString());
        if (match) {
          match.estatus = info.estatus;
          if(info.observacion) match.observacion = info.observacion;
        }
      });
    },
    saveAll(item) {
      let newArry = [];
      let nros = ''
      for (let i = 0; i < this.selected.length; i++) {
        let el = this.selected[i];
        if (i !== (i < this.selected.length - 1)) {
            nros += el.nro+', '
        } else nros += el.nro
        if (item === "P") {
          el.profit = true
          el.estatus = "Procesado"
        } else el.estatus = (item === "A") ? "Aprobado" : "Rechazado"
        newArry.push({
          _id: el._id,
          profit: el.profit,
          usuario: this.$store.state.adminsafiro._id,
          accion: 'Modificación de estatus por lote ('+el.estatus+')',
          estatus: el.estatus
        })
      }
      newArry[0].accion = newArry[0].accion+', Nros:'+nros
      if (newArry[0].estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            for (let i = 0; i < newArry.length; i++) {
              let el = newArry[i];
              el.observacion = result.value
            }
            this.dialog4 = true;
            Api.put("cobros/all", newArry)
              .then(() => {
                this.actualizarEstatusYObservacion(this.resultados, newArry, newArry[0]);
                this.actualizarEstatusYObservacion(this.resultadosres, newArry, newArry[0]);
                this.actualizarEstatusYObservacion(this.dataExcel, newArry, newArry[0]);
                this.$nextTick(() => {
                  this.selected = [];
                  this.$swal.fire(
                    "Felicidades.!",
                    "Modificación realizada exitosamente.",
                    "success"
                  );
                  this.dialog4 = false;
                })
              })
              .catch(err => {
                console.log(err);
                this.dialog4 = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.dialog4 = true;
        Api.put("cobros/all", newArry)
          .then(() => {
            this.actualizarEstatusYObservacion(this.resultados, newArry, newArry[0]);
            this.actualizarEstatusYObservacion(this.resultadosres, newArry, newArry[0]);
            this.actualizarEstatusYObservacion(this.dataExcel, newArry, newArry[0]);
            this.$nextTick(() => {
              this.selected = [];
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              this.dialog4 = false;
            })
          })
          .catch(err => {
            console.log(err);
            this.dialog4 = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    },
    save(item, mov = null) {
      let info
      if (item === "P") {
        info = {
          _id: this.form._id,
          profit: true,
          referencia: this.form.referencia,
          estatus: "Procesado"
        }
      } else if (item == "A" || item == "R") {
        info = {
          _id: this.form._id,
          referencia: this.form.referencia,
          mov: mov && mov.length > 0 ? mov[0] : null,
          estatus: (item === "A") ? "Aprobado" : "Rechazado"
        }
      } else {
        info = {
          _id: this.form._id,
          referencia: mov && mov.length > 0 ? mov[0].referencia : this.form.referencia,
          referenciaOld: mov && mov.length > 0 ? this.form.referencia : null,
          mov: mov && mov.length > 0 ? mov[0] : null,
          estatus: "Conciliado"
        }
      }
      if (info.estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            info.observacion = result.value
            info.usuario = this.$store.state.adminsafiro._id
            info.accion = 'Modificación de estatus (Rechazado), Nro: '+this.form.nro
            this.loading = true;
            Api.put("cobros", info)
              .then(() => {
                this.resultados.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.resultadosres.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.dataExcel.forEach(el=>{
                  if (el._id.toString() == this.form._id.toString()) el.estatus = info.estatus
                })
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.loading = true;
        info.usuario = this.$store.state.adminsafiro._id
        info.accion = 'Modificación de estatus ('+info.estatus+'), Nro: '+this.form.nro
        Api.put("cobros", info)
          .then(() => {
            this.closeMov();
            this.resultados.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.resultadosres.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.dataExcel.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    }
  }
};
</script>
<style lang="scss">
.v-datatable__actions__select {
  display: none;
}
table.v-table tbody td, table.v-table tbody th {
  height: auto;
}
</style>
